<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="data-list-list-view" class="data-list-container m-5">
    <div class="vx-row">
 
      <h2  style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('Profit')}} </h2> 
      <vs-input  v-model="annualPlanBudgetModel.Profit" @change="CalculateTotal()" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
           
 </div>
 <vx-card class="flex-1 " :title="$t('InstructorServices')"  style="margin-top:15px">
 
 <div class="vx-row">

    <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('InstructorFee')}} </p> 
    <vs-input class="md:w-1/5 w-full " :label="$t('FeePerDay')" @change="CalculateTotal()" v-model="annualPlanBudgetModel.InstructorDailyRate"  name="Name"  style="padding-right:20px;padding-left:20px"/>
    <vs-input class="md:w-1/5 w-full " :label="$t('OfDays')" @change="CalculateTotal()" v-model="annualPlanBudgetModel.NumOfCourseDays"   name="Name"  style="padding-right:20px;padding-left:20px"/>
    <vs-input class="md:w-1/5 w-full " :label="$t('OfCourses')" @change="CalculateTotal()" v-model="NumberOFCourse" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px"/>
    <!-- <vs-input class="md:w-1/5 w-full " label="sub total" v-model="totalDailyRate" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px"/> -->
    <div class="vx-col">
        <label style="padding-right:20px;padding-top:20px;">{{$t('SubTotal')}}</label>
        <h3 style="padding-right:20px;padding-top:20px;" v-if="annualPlanBudgetModel.InstructorDailyRate&&annualPlanBudgetModel.NumOfCourseDays">{{annualPlanBudgetModel.InstructorDailyRate*annualPlanBudgetModel.NumOfCourseDays}}</h3>
    </div>
    
 </div>

 <div class="vx-row">
    <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('InstructorFeeReport')}} </p> 
    <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.PreparationAndReport" name="Name" style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.PreparationAndReportDays" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"  name="Name" :disabled="true" style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full "  v-model="totalPreparationAndReportDays" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.PreparationAndReport&&annualPlanBudgetModel.PreparationAndReportDays">{{annualPlanBudgetModel.PreparationAndReport*annualPlanBudgetModel.PreparationAndReportDays}}</h3>
 </div>

  <div class="vx-row">

 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('DailySubsistence')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.DailySubsistenceAllowance"  name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.DailySubsistenceAllowanceDays"   name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="NumberOFCourse" name="Name" :disabled="true"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full "  v-model="totalDailySubsistenceAllowance" :disabled="true"  name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.DailySubsistenceAllowance&&annualPlanBudgetModel.DailySubsistenceAllowanceDays">{{annualPlanBudgetModel.DailySubsistenceAllowance*annualPlanBudgetModel.DailySubsistenceAllowanceDays}}</h3>
 </div>
 <div class="vx-row">

 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('DSAweekends')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('FeePerDay')" v-model="annualPlanBudgetModel.DSAWeekend" name="Name"  style="padding-right:20px;padding-left:20px"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfDays')" v-model="annualPlanBudgetModel.DSAWeekendDays" name="Name"  style="padding-right:20px;padding-left:20px"/>
    <vs-input class="md:w-1/5 w-full "  @change="CalculateTotal()" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full " label="sub total" v-model="totalDSAWeekend" name="Name"  style="padding-right:20px;padding-left:20px"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.DSAWeekend&&annualPlanBudgetModel.DSAWeekendDays">{{annualPlanBudgetModel.DSAWeekend*annualPlanBudgetModel.DSAWeekendDays}}</h3>
 </div>

 <h1 >{{$t('ClassRoom')}}</h1>
  <div class="vx-row">
  <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('ClassRoomFees')}} </p> 
  <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"  :label="$t('FeePerDay')" v-model="annualPlanBudgetModel.ClassroomOperating" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
  <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfDays')" v-model="annualPlanBudgetModel.ClassroomDays" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
      <vs-input class="md:w-1/5 w-full "  @change="CalculateTotal()" disabled="true"  name="Name"  style="padding-right:20px;padding-left:20px;padding-top:40px;"/>
      <!-- <vs-input class="md:w-1/5 w-full "  v-model="annualPlanBudgetModel.MinNoOfTrainee" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
      <h3 style="padding-right:20px;padding-left:20px;padding-top:40px;" v-if="annualPlanBudgetModel.ClassroomDays&&annualPlanBudgetModel.ClassroomOperating">{{annualPlanBudgetModel.ClassroomDays*annualPlanBudgetModel.ClassroomOperating}}</h3>
 </div>

     <h1 class="mt-5">{{$t('Travel')}}</h1>
 
 <div class="vx-row">
 
 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('AirTicket')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('CostPerTicket')" v-model="annualPlanBudgetModel.CostOfTicket" name="Name"  style="padding-right:20px;padding-left:20px"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"  :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px"/>
    <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfTickets')" v-model="annualPlanBudgetModel.NumOfTicket" name="Name"  style="padding-right:20px;padding-left:20px"/>
    <!-- <vs-input class="md:w-1/5 w-full " :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.NumOfTicket&&annualPlanBudgetModel.CostOfTicket">{{annualPlanBudgetModel.NumOfTicket*annualPlanBudgetModel.CostOfTicket}}</h3>
 </div>

 <div class="vx-row">
 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('TerminalAllowance')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.TerminalAllowance" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"  name="Name" :disabled="true" style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
  <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.NumOfAllowance" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full "  v-model="annualPlanBudgetModel.MinNoOfTrainee" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.TerminalAllowance&&annualPlanBudgetModel.NumOfAllowance">{{annualPlanBudgetModel.TerminalAllowance*annualPlanBudgetModel.NumOfAllowance}}</h3>
 </div>

  </vx-card>
      
 <vx-card class="flex-1 " :title="$t('TrainingFees')"  style="margin-top:15px">
 
 <div class="vx-row">
  
 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('CourseFees')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('FeePerTrainee')" v-model="annualPlanBudgetModel.CourseFees" name="Name"  style="padding-right:20px;padding-left:20px;"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px"/>
    <!-- <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfTrainee')	" v-model="annualPlanBudgetModel.NumOfTrainee" name="Name"  style="padding-right:20px;padding-left:20px"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.NumOfTrainee&&annualPlanBudgetModel.CourseFees">{{annualPlanBudgetModel.NumOfTrainee*annualPlanBudgetModel.CourseFees}}</h3>
 
 </div>

  <div class="vx-row">
  
 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">{{$t('HostingFees')}} </p> 
 <vs-input class="md:w-1/5 w-full mt-5" @change="CalculateTotal()"  v-model="annualPlanBudgetModel.HostingFess" name="Name"  style="padding-right:20px;padding-left:20px;"/>
 <div class="md:w-1/5 w-full "   style="padding-right:20px;padding-left:20px;padding-top:20px"></div>
  <div class="md:w-1/5 w-full "    style="padding-right:20px;padding-left:20px"></div>
 <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.HostingFess">{{annualPlanBudgetModel.HostingFess}}</h3>
 
 </div>



 <div class="vx-row">
 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('TabletOrHandout')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.TabletOrHandout" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.NumOfTabletOrHandout" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.NumOfTabletOrHandout&&annualPlanBudgetModel.TabletOrHandout">{{annualPlanBudgetModel.NumOfTabletOrHandout*annualPlanBudgetModel.TabletOrHandout}}</h3>
 
 </div>

 <div class="vx-row">

 <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{$t('Transportation')}} </p> 
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.Transportation" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
 <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"  :disabled="true" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/>
    <!-- <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="annualPlanBudgetModel.NumOfTransportation" name="Name"  style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
    <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;" v-if="annualPlanBudgetModel.NumOfTransportation&&annualPlanBudgetModel.Transportation" >{{annualPlanBudgetModel.NumOfTransportation*annualPlanBudgetModel.Transportation}}</h3>
 
 </div>

  </vx-card> 
  
      <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
          
          <div>
          </div>
           <div class="vx-row">

                  <!-- <feather-icon
                    icon="RefreshIcon"
                    @click="CalculateTotal()"
                    class="p-2 mt-10 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                    /> -->
                <vs-input  v-model="feesParTrainee" :disabled="true" name="Name" :label="$t('CoursePerTrainee')" style="padding-right:20px;padding-left:20px;padding-top:20px;"/>

                <!-- <vs-input  v-model="totalFees" :disabled="true" name="total"  label="total" style="padding-right:20px;padding-left:20px;padding-top:20px;"/> -->
           </div>
      </div>
   
  </div>
</template>


<script>

import moduleAnnualPlan from "@/store/annualPlan/moduleAnnualPlan.js";
export default {
  components: {
    
  },
  data() {
    return {
      totalFees:0,
      feesParTrainee:0,
      NumberOFCourse:1,
      //annualPlanBudgetModel:{},
    
    };
  },
   props: {
    annualPlanBudgetModel: {
      type: Object,
     required: true,
    }
  },
  computed: {
    
  },

  methods: {
    CalculateTotal()
    {
       this.totalFees=0;
       if(this.annualPlanBudgetModel.InstructorDailyRate&&this.annualPlanBudgetModel.NumOfCourseDays)
        this.totalFees += this.annualPlanBudgetModel.InstructorDailyRate*this.annualPlanBudgetModel.NumOfCourseDays;
       if(this.annualPlanBudgetModel.PreparationAndReport&&this.annualPlanBudgetModel.PreparationAndReportDays) 
        this.totalFees += this.annualPlanBudgetModel.PreparationAndReport*this.annualPlanBudgetModel.PreparationAndReportDays;
      if(this.annualPlanBudgetModel.DailySubsistenceAllowance&&this.annualPlanBudgetModel.DailySubsistenceAllowanceDays)
        this.totalFees += this.annualPlanBudgetModel.DailySubsistenceAllowance*this.annualPlanBudgetModel.DailySubsistenceAllowanceDays;
      if(this.annualPlanBudgetModel.DSAWeekend&&this.annualPlanBudgetModel.DSAWeekendDays)
         this.totalFees += this.annualPlanBudgetModel.DSAWeekend*this.annualPlanBudgetModel.DSAWeekendDays;
      if(this.annualPlanBudgetModel.ClassroomDays&&this.annualPlanBudgetModel.ClassroomOperating)
        this.totalFees += this.annualPlanBudgetModel.ClassroomDays*this.annualPlanBudgetModel.ClassroomOperating;
      if(this.annualPlanBudgetModel.NumOfTicket&&this.annualPlanBudgetModel.CostOfTicket)  
        this.totalFees += this.annualPlanBudgetModel.NumOfTicket*this.annualPlanBudgetModel.CostOfTicket;
      if(this.annualPlanBudgetModel.TerminalAllowance&&this.annualPlanBudgetModel.NumOfAllowance)
         this.totalFees += this.annualPlanBudgetModel.TerminalAllowance*this.annualPlanBudgetModel.NumOfAllowance;
      if(this.annualPlanBudgetModel.NumOfTrainee&&this.annualPlanBudgetModel.CourseFees)
         this.totalFees += this.annualPlanBudgetModel.NumOfTrainee*this.annualPlanBudgetModel.CourseFees;
      if(this.annualPlanBudgetModel.NumOfTabletOrHandout&&this.annualPlanBudgetModel.TabletOrHandout)
         this.totalFees += this.annualPlanBudgetModel.NumOfTabletOrHandout*this.annualPlanBudgetModel.TabletOrHandout;
      if(this.annualPlanBudgetModel.NumOfTransportation&&this.annualPlanBudgetModel.Transportation)
         this.totalFees += this.annualPlanBudgetModel.NumOfTransportation*this.annualPlanBudgetModel.Transportation;
      if(this.annualPlanBudgetModel.HostingFess)
             this.totalFees += parseFloat( this.annualPlanBudgetModel.HostingFess)
      if(this.annualPlanBudgetModel.Profit==undefined)
      {
       this.annualPlanBudgetModel.Profit=0;
      }

        this.totalFees= this.totalFees+ (this.totalFees*this.annualPlanBudgetModel.Profit)/100;
         this.annualPlanBudgetModel.totalFees =this.totalFees ;
         this.feesParTrainee= (this.totalFees/ this.annualPlanBudgetModel.NumOfTrainee).toFixed(2);
         this.annualPlanBudgetModel.feesParTrainee =this.feesParTrainee.toFixed(2) ;
    },
  // this.notifyAlert("danger","Error","Please add all required contact info Email, Work Email, Mobile");
    notifyAlert(color,title,text) {
      this.$vs.notify({
        fixed:true,
        color: color,
        title: title,
        text: text
      });
    },
    

  },

  created() {
    if (!moduleAnnualPlan.isRegistered) {
      this.$store.registerModule("annualPlanList", moduleAnnualPlan);
      moduleAnnualPlan.isRegistered = true;
    }
    this.annualPlanBudgetModel.NumOfTabletOrHandout=1;
    this.annualPlanBudgetModel.NumOfTrainee=1;
    this.annualPlanBudgetModel.NumOfTransportation=1;

      this.CalculateTotal();
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
}
  .con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  
  }
}
</style>
